module.exports = __webpack_public_path__ + "static/media/Illus-Dressing_2@3x.4ba06532.png";